import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Configuración optimizada para mejor rendimiento y estabilidad
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  // Configuración de conexión optimizada
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Configuración más robusta para evitar desconexiones
    flowType: 'pkce'
  },
  // Configuración de consultas optimizada
  db: {
    schema: 'public'
  },
  // Configuración de tiempo de espera optimizada
  global: {
    headers: {
      'X-Client-Info': 'productex-app/1.0.0'
    },
    // Timeout más largo para conexiones lentas
    fetch: (url, options = {}) => {
      return fetch(url, {
        ...options,
        // Timeout de 60 segundos para operaciones críticas
        signal: AbortSignal.timeout(60000)
      });
    }
  },
  // Configuración de reintentos y timeouts
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Cliente optimizado para consultas de solo lectura (más rápido)
export const supabaseReadOnly = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'X-Client-Info': 'productex-app-readonly/1.0.0'
    }
  }
});

// Cliente para operaciones críticas con timeouts más largos
export const supabaseCritical = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'X-Client-Info': 'productex-app-critical/1.0.0'
    }
  }
});